/*
 * Decimal, Account Management App.
 * Copyright (C) 2008-2013 Decimal
 * mailto:contact AT decimal DOT co DOT in
 *
 * Account is Decimal software; you can not redistribute it.
 * any versions of the License.
 * License is private by the Decimal Foundation;
 *
 * Inc., 8th Floor, Tower – D, Pioneer Urban Square, Golf Course Ext Rd,
 * Sector 62, Gurugram, Haryana 122102
 */

import { HttpRequest, HttpHandler } from '@angular/common/http';
import { Injectable } from '@angular/core';

/**
 * Intercepts and handles an `HttpRequest` or `HttpResponse`.
 * This intercepter will intercept request/response and perform following operations
 *  1. Print
 *  2. Request/Response Modification
 *  3. add selected org_id and api_id in header for cache
 */
@Injectable()
export class HttpInterceptor implements HttpInterceptor {
  /**
   * intercept
   * @param req:
   * @param next:
   * @returns Observable<HttpEvent<any>>
   */
  intercept(req, next: HttpHandler) {
    req = addTokens(req);
    return next.handle(req);
  }
}

/**
 * Current Api Request format
 * @param request to be send
 */
function addTokens(request) {
  return request.clone({});
}
